export const AGGREGATION_PRICE = {
    MIN: 'min',
    MAX: 'max',
    AVG: 'avg'
}

export const HOW_TO_GROUP = {
    PROVIDER_PICKUP: "provider-pickup",
    CATEGORY_PICKUP: "category-pickup",
    LOR_PICKUP: "lor-pickup",
    BOOKING_PICKUP: "booking-pickup",
    OFFICE_BOOKING: "office-booking",
    PROVIDER_BOOKING: "provider-booking",
    SITE_BOOKING: "site-booking",
    PROVIDER_OFFICE: "provider-office"
};
